/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  UserFlagsModeratorControllerPatchMutationRequest,
  UserFlagsModeratorControllerPatchMutationResponse,
  UserFlagsModeratorControllerPatchPathParams,
  UserFlagsModeratorControllerPatch401,
  UserFlagsModeratorControllerPatch404,
} from '../../types/UserFlagsModeratorControllerPatch.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { userFlagsModeratorPatch } from '../../methods/userFlagsModeratorPatch.ts';
import { useMutation } from '@tanstack/react-query';

export const userFlagsModeratorPatchMutationKey = () => [{ url: '/api/moderator/user-flags/:id' }] as const;

export type UserFlagsModeratorPatchMutationKey = ReturnType<typeof userFlagsModeratorPatchMutationKey>;

/**
 * {@link /api/moderator/user-flags/:id}
 */
export function useUserFlagsModeratorPatch<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UserFlagsModeratorControllerPatchMutationResponse,
      ResponseErrorConfig<UserFlagsModeratorControllerPatch401 | UserFlagsModeratorControllerPatch404>,
      {
        id: UserFlagsModeratorControllerPatchPathParams['id'];
        data?: UserFlagsModeratorControllerPatchMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<UserFlagsModeratorControllerPatchMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? userFlagsModeratorPatchMutationKey();

  return useMutation<
    UserFlagsModeratorControllerPatchMutationResponse,
    ResponseErrorConfig<UserFlagsModeratorControllerPatch401 | UserFlagsModeratorControllerPatch404>,
    { id: UserFlagsModeratorControllerPatchPathParams['id']; data?: UserFlagsModeratorControllerPatchMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return userFlagsModeratorPatch(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
